// extracted by mini-css-extract-plugin
export default {"iconTextButton":"icon-text-button__iconTextButton"};